import $ from "jquery";

export const update = () => {
  const body = $("body");
  const metaThemeColor = $('meta[name="theme-color"]');

  if (body.hasClass("colorSepia")) {
    metaThemeColor.attr("content", "#F0EEDF");
  } else if (body.hasClass("colorDark")) {
    metaThemeColor.attr("content", "#222222");
  } else {
    metaThemeColor.attr("content", "#43B08A");
  }
};
